"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.antdComponents = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _makeStyle = _interopRequireDefault(require("../utils/makeStyle"));
var _statistic = require("../utils/statistic");
var _ComponentCard = require("./ComponentCard");
var _ComponentDemoGroup = _interopRequireDefault(require("./ComponentDemoGroup"));
var _ComponentTree = _interopRequireDefault(require("./ComponentTree"));
var _excluded = ["themes", "selectedTokens", "filterMode", "className", "onTokenClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var BREADCRUMB_HEIGHT = 40;
var useStyle = (0, _makeStyle.default)('ComponentPanel', function (token) {
  return {
    '.component-panel': {
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.05), 0 1px 2px 0 rgba(25,15,15,0.07), 0 0 1px 0 rgba(0,0,0,0.08)',
      backgroundColor: '#fff',
      display: 'flex',
      borderRadius: 6,
      height: '100%',
      overflow: 'hidden',
      '.component-panel-main': {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        width: 0,
        '.component-panel-head': (0, _defineProperty2.default)({
          padding: "".concat(token.paddingSM, "px ").concat(token.paddingSM, "px"),
          flex: 'none',
          backgroundColor: token.colorBgContainer,
          display: 'flex',
          alignItems: 'center',
          borderBottom: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorBgContainer),
          '> *:not(:first-child)': {
            marginInlineStart: token.margin
          }
        }, "".concat(token.rootCls, "-segmented-item"), {
          minWidth: 52
        }),
        '.component-panel-toggle-side-icon': {
          flex: 'none',
          cursor: 'pointer',
          marginInlineEnd: token.marginXS,
          '.anticon': {
            color: token.colorIcon,
            transition: "color ".concat(token.motionDurationMid),
            '&:hover': {
              color: token.colorIconHover
            }
          }
        }
      },
      '.component-panel-side': {
        flex: 'none',
        width: 200,
        overflow: 'hidden',
        transition: "transform ".concat(token.motionDurationMid, ", width ").concat(token.motionDurationMid)
      },
      '.component-panel-side.component-panel-side-hidden': {
        width: 0,
        transform: 'translateX(-200px)'
      },
      '.component-demos-wrapper': {
        display: 'flex',
        flex: 1,
        height: 0,
        position: 'relative',
        '.component-demos-breadcrumb-wrapper': {
          position: 'absolute',
          top: 0,
          insetInlineStart: 0,
          width: '100%',
          height: BREADCRUMB_HEIGHT,
          zIndex: 20,
          backgroundColor: token.colorBgContainer,
          padding: '8px 16px',
          transition: 'opacity 0.3s',
          background: 'rgba(255, 255, 255, .6)',
          backdropFilter: 'blur(10px)',
          borderBottom: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorBgContainer)
        }
      },
      '.component-demos': {
        height: '100%',
        overflow: 'auto',
        flex: 1
      }
    }
  };
});
var antdComponents = exports.antdComponents = {
  General: ['Button', 'Icon', 'Typography'],
  Layout: ['Divider', 'Grid', 'Layout', 'Space'],
  Navigation: ['Anchor', 'Breadcrumb', 'Dropdown', 'Menu', 'Pagination', 'Steps'],
  'Data Entry': ['AutoComplete', 'Cascader', 'Checkbox', 'DatePicker', 'Form', 'Input', 'InputNumber', 'Mentions', 'Radio', 'Rate', 'Select', 'Slider', 'Switch', 'TimePicker', 'Transfer', 'TreeSelect', 'Upload'],
  'Data Display': ['Avatar', 'Badge', 'Calendar', 'Card', 'Carousel', 'Collapse', 'Descriptions', 'Empty', 'Image', 'List', 'Popover', 'Segmented', 'Statistic', 'Table', 'Tabs', 'Tag', 'Timeline', 'Tooltip', 'Tree'],
  Feedback: ['Alert', 'Drawer', 'Message', 'Modal', 'Notification', 'Popconfirm', 'Progress', 'Result', 'Skeleton', 'Spin']
};
var Index = function Index(_ref) {
  var _Object$entries$find2;
  var themes = _ref.themes,
    selectedTokens = _ref.selectedTokens,
    filterMode = _ref.filterMode,
    className = _ref.className,
    onTokenClick = _ref.onTokenClick,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    wrapSSR = _useStyle2[0],
    hashId = _useStyle2[1];
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showSide = _useState2[0],
    setShowSide = _useState2[1];
  var demosRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)('middle'),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    componentSize = _useState4[0],
    setComponentSize = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    componentDisabled = _useState6[0],
    setComponentDisabled = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    activeComponent = _useState8[0],
    setActiveComponent = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    showBreadcrumb = _useState10[0],
    setShowBreadcrumb = _useState10[1];
  var relatedComponents = (0, _react.useMemo)(function () {
    return selectedTokens ? (0, _statistic.getRelatedComponents)(selectedTokens) : [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTokens]);
  (0, _react.useEffect)(function () {
    setShowSide(true);
  }, [selectedTokens]);
  (0, _react.useEffect)(function () {
    var _demosRef$current;
    var handleScroll = function handleScroll() {
      if (demosRef.current) {
        setShowBreadcrumb(demosRef.current.scrollTop > 10);
        for (var i = 0; i < demosRef.current.children.length; i++) {
          if (demosRef.current.children[i].getBoundingClientRect().top + demosRef.current.children[i].clientHeight - demosRef.current.getBoundingClientRect().top > BREADCRUMB_HEIGHT) {
            var _demosRef$current$chi;
            setActiveComponent((_demosRef$current$chi = demosRef.current.children[i]) === null || _demosRef$current$chi === void 0 ? void 0 : _demosRef$current$chi.id.split('-').pop());
            break;
          }
        }
      }
    };
    (_demosRef$current = demosRef.current) === null || _demosRef$current === void 0 || _demosRef$current.addEventListener('scroll', handleScroll);
    var demosWrapper = demosRef.current;
    return function () {
      demosWrapper === null || demosWrapper === void 0 || demosWrapper.removeEventListener('scroll', handleScroll);
    };
  }, []);
  var scrollToComponent = function scrollToComponent(component) {
    var _demosRef$current2, _demosRef$current3;
    (_demosRef$current2 = demosRef.current) === null || _demosRef$current2 === void 0 || _demosRef$current2.scrollTo({
      top: (((_demosRef$current3 = demosRef.current) === null || _demosRef$current3 === void 0 || (_demosRef$current3 = _demosRef$current3.querySelector("#".concat((0, _ComponentCard.getComponentDemoId)(component)))) === null || _demosRef$current3 === void 0 ? void 0 : _demosRef$current3.offsetTop) || 0) - 38,
      behavior: 'smooth'
    });
  };
  var activeComponentCategory = (0, _react.useMemo)(function () {
    var _Object$entries$find;
    if (!activeComponent) {
      return undefined;
    }
    var key = (_Object$entries$find = Object.entries(antdComponents).find(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        value = _ref3[1];
      return value.includes(activeComponent);
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[0];
    if (key) {
      return antdComponents[key];
    } else {
      return undefined;
    }
  }, [activeComponent]);
  var demoGroup = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_ComponentDemoGroup.default, {
      themes: themes,
      components: antdComponents,
      size: componentSize,
      disabled: componentDisabled,
      activeComponents: filterMode === 'highlight' ? undefined : relatedComponents,
      selectedTokens: selectedTokens,
      onTokenClick: onTokenClick
    });
  }, [themes, componentSize, componentDisabled, filterMode, relatedComponents, selectedTokens, onTokenClick]);
  return wrapSSR( /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('component-panel', hashId, className)
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('component-panel-side', {
      'component-panel-side-hidden': !showSide
    })
  }, /*#__PURE__*/_react.default.createElement(_ComponentTree.default, {
    activeComponent: activeComponent,
    filterMode: filterMode,
    selectedTokens: selectedTokens,
    components: antdComponents,
    onSelect: function onSelect(component) {
      if (component.startsWith('type-')) {
        scrollToComponent(antdComponents[component.split('-')[1]][0]);
      } else {
        scrollToComponent(component);
      }
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "component-panel-main"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "component-panel-head"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "component-panel-toggle-side-icon",
    onClick: function onClick() {
      return setShowSide(function (prev) {
        return !prev;
      });
    }
  }, showSide ? /*#__PURE__*/_react.default.createElement(_icons.MenuFoldOutlined, null) : /*#__PURE__*/_react.default.createElement(_icons.MenuUnfoldOutlined, null)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginRight: 8
    }
  }, "\u7EC4\u4EF6\u5C3A\u5BF8\uFF1A"), /*#__PURE__*/_react.default.createElement(_antd.Segmented, {
    value: componentSize,
    onChange: function onChange(value) {
      return setComponentSize(value);
    },
    options: [{
      label: '大',
      value: 'large'
    }, {
      label: '中',
      value: 'middle'
    }, {
      label: '小',
      value: 'small'
    }]
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginRight: 8,
      verticalAlign: 'middle'
    }
  }, "\u7981\u7528\uFF1A"), /*#__PURE__*/_react.default.createElement(_antd.Switch, {
    checked: componentDisabled,
    onChange: function onChange(checked) {
      return setComponentDisabled(checked);
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "component-demos-wrapper"
  }, activeComponent && /*#__PURE__*/_react.default.createElement("div", {
    className: "component-demos-breadcrumb-wrapper",
    style: {
      opacity: showBreadcrumb ? 1 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb, null, /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, null, /*#__PURE__*/_react.default.createElement("a", {
    onClick: function onClick() {
      return activeComponentCategory && scrollToComponent(activeComponentCategory === null || activeComponentCategory === void 0 ? void 0 : activeComponentCategory[0]);
    }
  }, (_Object$entries$find2 = Object.entries(antdComponents).find(function (_ref4) {
    var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
      value = _ref5[1];
    return value.includes(activeComponent);
  })) === null || _Object$entries$find2 === void 0 ? void 0 : _Object$entries$find2[0])), /*#__PURE__*/_react.default.createElement(_antd.Breadcrumb.Item, null, activeComponent))), /*#__PURE__*/_react.default.createElement("div", {
    className: "component-demos",
    ref: demosRef
  }, demoGroup)))));
};
var _default = exports.default = Index;